import React from "react";
// import mock01 from '../assets/images/mock01.png';
// import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://ammikidswear.com/" target="_blank" rel="noreferrer"><img src={mock10} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://ammikidswear.com/" target="_blank" rel="noreferrer"><h2>Ammikidswear</h2></a>
                <p>Ecommerce Webstore using rhobust technology having a backend admin panel for tracking orders and inventory.</p>
            </div>
            <div className="project">
                <a href="https://staging.gloriouselectronics.in/" target="_blank" rel="noreferrer"><img src={mock09} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://staging.gloriouselectronics.in/" target="_blank" rel="noreferrer"><h2>Gloriouselectronics</h2></a>
                <p>Ecommerce Webstore using having python with Django on application side and react/nextjs in frontend.</p>
            </div>
            <div className="project">
                <a href="https://kidoschools.com" target="_blank" rel="noreferrer"><img src={mock08} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://kidoschools.com" target="_blank" rel="noreferrer"><h2>Kidoschools</h2></a>
                <p>Wordpress website with fully templates designed as per need and having a customized plugins and admin panel for theme.</p>
            </div>
            <div className="project">
                <a href="https://albaqi.net/" target="_blank" rel="noreferrer"><img src={mock07} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://albaqi.net/" target="_blank" rel="noreferrer"><h2>Al Baqi Tours & Travels</h2></a>
                <p>Wordpress website with fully templates designed as per need and having a customized plugins and admin panel for theme.</p>
            </div>
            <div className="project">
                <a href="https://skcivil.in/" target="_blank" rel="noreferrer"><img src={mock06} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://skcivil.in/" target="_blank" rel="noreferrer"><h2>Real Estate Website</h2></a>
                <p>Website for marketing and promotion of services helps in branding and maintaining digital presence on the internet and web.</p>
            </div>
            <div className="project">
                <a href="https://themanagemate.com/" target="_blank" rel="noreferrer"><img src={mock05} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://themanagemate.com/" target="_blank" rel="noreferrer"><h2>Personal mobile responsive website</h2></a>
                <p>Website for marketing and promotion of services helps in branding and maintaining digital presence on the internet and web.</p>
            </div>
            <div className="project">
                <a href="https://bibicloth.com/" target="_blank" rel="noreferrer"><img src={mock04} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://bibicloth.com/" target="_blank" rel="noreferrer"><h2>BiBi Cloth</h2></a>
                <p>Single page Landing Page website for Marketing and promotions over digital ads marketing.</p>
            </div>
            <div className="project">
                <a href="https://sageunani.com/" target="_blank" rel="noreferrer"><img src={mock03} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://sageunani.com/" target="_blank" rel="noreferrer"><h2>Sage Unani</h2></a>
                <p>Wordpress website with fully templates designed as per need and having a customized plugins and admin panel for theme.</p>
            </div>

        </div>
    </div>
    );
}

export default Project;